import React, { useState } from 'react';

const CommonImage = ({
  src,
  alt,
  width,
  height,
  className = '',
  style = {},
  role,
  loading = 'lazy',
  onClick
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      style={{
        width: width || style.width || 'auto',
        height: height || style.height || 'auto',
        position: 'relative',
        overflow: 'hidden',
        // display: 'inline-block',
        ...style
      }}
      className={`inline-block ${className}`}
      role={role}
      onClick={onClick}
    >
      {!loaded && (
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#e0e0e0',
            animation: 'pulse 1.5s infinite ease-in-out',
            position: 'absolute',
            top: 0,
            left: 0
          }}
        />
      )}

      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out'
        }}
        loading={loading}
        onLoad={() => setLoaded(true)}
      />

      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default CommonImage;
